function waitForSlick(callback, attempts = 0) {
  if (window.jQuery && window.jQuery.fn && window.jQuery.fn.slick) {
    callback(window.jQuery);
    return;
  }
  if (attempts > 40) return;
  setTimeout(() => waitForSlick(callback, attempts + 1), 150);
}

function getVariantMediaInfo(variant) {
  if (!variant) return null;
  const mediaId = variant.featured_media?.id || variant.featured_image?.id;
  const imageSrc =
    variant.featured_media?.preview_image?.src || variant.featured_image?.src;
  if (!mediaId && !imageSrc) return null;
  return { mediaId, imageSrc };
}

function initProductGallerySlick(scope, onReady) {
  const root = scope && scope.querySelectorAll ? scope : document;

  waitForSlick(($) => {
    root.querySelectorAll("media-gallery").forEach((mediaGallery, index) => {
      const mainSlider = mediaGallery.querySelector('[id^="Slider-Gallery-"]');
      const thumbSlider = mediaGallery.querySelector('[id^="Slider-Thumbnails-"]');
      if (!mainSlider) return;

      const $main = $(mainSlider);
      if ($main.hasClass("slick-initialized")) $main.slick("unslick");

      const mainId = mainSlider.id || `product-main-slider-${index}`;
      mainSlider.id = mainId;

      const mainOptions = {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        infinite: false,
        adaptiveHeight: false,
        prevArrow:
          '<button type="button" class="slick-prev custom-gallery-arrow" aria-label="Anterior">‹</button>',
        nextArrow:
          '<button type="button" class="slick-next custom-gallery-arrow" aria-label="Próxima">›</button>',
      };

      if (thumbSlider) {
        const $thumbs = $(thumbSlider);
        if ($thumbs.hasClass("slick-initialized")) $thumbs.slick("unslick");
        const thumbId = thumbSlider.id || `product-thumb-slider-${index}`;
        thumbSlider.id = thumbId;
        mainOptions.asNavFor = `#${thumbId}`;
        $main.slick(mainOptions);
        $thumbs.slick({
          slidesToShow: 5,
          slidesToScroll: 1,
          asNavFor: `#${mainId}`,
          dots: false,
          arrows: true,
          infinite: false,
          focusOnSelect: true,
          prevArrow:
            '<button type="button" class="slick-prev custom-gallery-thumb-arrow" aria-label="Anterior miniatura">‹</button>',
          nextArrow:
            '<button type="button" class="slick-next custom-gallery-thumb-arrow" aria-label="Próxima miniatura">›</button>',
          responsive: [
            { breakpoint: 990, settings: { slidesToShow: 4 } },
            { breakpoint: 749, settings: { slidesToShow: 3, arrows: true } },
          ],
        });
      } else {
        $main.slick(mainOptions);
      }
    });

    if (typeof onReady === "function") onReady();
  });
}

function forceUpdateVisibleImage(gallery, imageSrc) {
  if (!imageSrc || !gallery) return;

  const mainSlider = gallery.querySelector('[id^="Slider-Gallery-"]');
  if (!mainSlider) return;

  const activeSlide =
    mainSlider.querySelector(".slick-slide.slick-current:not(.slick-cloned)") ||
    mainSlider.querySelector(".product__media-item");

  const img = activeSlide?.querySelector("img");
  if (!img) return;

  img.removeAttribute("srcset");
  img.removeAttribute("sizes");
  img.src = imageSrc;
}

function findSlideIndex(mainSlider, mediaId) {
  const slides = mainSlider.querySelectorAll(".slick-slide:not(.slick-cloned)");
  for (let i = 0; i < slides.length; i++) {
    const item = slides[i].querySelector("[data-media-id]");
    if (item && mediaId && item.dataset.mediaId.endsWith(`-${mediaId}`)) {
      return i;
    }
  }
  const items = mainSlider.querySelectorAll("[data-media-id]");
  for (let i = 0; i < items.length; i++) {
    if (mediaId && items[i].dataset.mediaId.endsWith(`-${mediaId}`)) return i;
  }
  return 0;
}

function goToVariantMedia(gallery, mediaInfo) {
  if (!mediaInfo || !window.jQuery) return;

  const mainSlider = gallery.querySelector('[id^="Slider-Gallery-"]');
  const thumbSlider = gallery.querySelector('[id^="Slider-Thumbnails-"]');
  if (!mainSlider) return;

  const $main = window.jQuery(mainSlider);
  const targetIndex = findSlideIndex(mainSlider, mediaInfo.mediaId);

  const navigate = () => {
    if (!$main.hasClass("slick-initialized")) return false;
    $main.slick("slickGoTo", targetIndex, true);
    if (thumbSlider) {
      const $thumbs = window.jQuery(thumbSlider);
      if ($thumbs.hasClass("slick-initialized")) {
        $thumbs.slick("slickGoTo", targetIndex, true);
      }
    }
    return true;
  };

  if (!navigate()) {
    setTimeout(navigate, 300);
  }
}

function refreshGalleryFromServer(productInfo, variant, callback) {
  const sectionId = productInfo.dataset.section;
  const url = `${productInfo.dataset.url}?variant=${variant.id}&section_id=${sectionId}`;

  fetch(url)
    .then((r) => r.text())
    .then((text) => {
      const html = new DOMParser().parseFromString(text, "text/html");
      refreshModalContent(html, sectionId); 
      const newGallery = html.querySelector("media-gallery");
      const gallery = productInfo.querySelector("media-gallery");

      if (newGallery && gallery) {
        gallery.innerHTML = newGallery.innerHTML;
        initProductGallerySlick(productInfo, callback);
      } else if (callback) {
        callback();
      }
    })
    .catch(() => {
      if (callback) callback();
    });
}

function syncZoomButtonMediaId(gallery, mediaId) {
  if (!gallery || !mediaId) return;

  const mainSlider = gallery.querySelector('[id^="Slider-Gallery-"]');
  if (!mainSlider) return;

  const activeSlide =
    mainSlider.querySelector(".slick-slide.slick-current:not(.slick-cloned)") ||
    mainSlider.querySelector(".product__media-item");

  const zoomBtn = activeSlide?.querySelector("button[data-media-id]");
  if (zoomBtn) {
    zoomBtn.setAttribute("data-media-id", String(mediaId));
  }
}

function refreshModalContent(html, sectionId) {
  const modalContent = document.querySelector(
    `#ProductModal-${sectionId} .product-media-modal__content`
  );
  const newModalContent =
    html.querySelector("product-modal .product-media-modal__content") ||
    html.querySelector(".product-media-modal__content");

  if (modalContent && newModalContent) {
    modalContent.innerHTML = newModalContent.innerHTML;
  }
}

function updateGalleryForVariant(variant) {
  const mediaInfo = getVariantMediaInfo(variant);
  if (!mediaInfo) return;

  const productInfo = document.querySelector("product-info");
  const gallery = productInfo?.querySelector("media-gallery");
  if (!gallery) return;

  const targetSlide = gallery.querySelector(
    `[data-media-id$="-${mediaInfo.mediaId}"]`
  );

  const applyImage = () => {
  if (targetSlide) {
    goToVariantMedia(gallery, mediaInfo);
  }
  forceUpdateVisibleImage(gallery, mediaInfo.imageSrc);
  syncZoomButtonMediaId(gallery, mediaInfo.mediaId);
};

  if (!targetSlide) {
    refreshGalleryFromServer(productInfo, variant, applyImage);
  } else {
    applyImage();
  }
}

function onVariantSelected() {
  const el = document.querySelector("[data-selected-variant]");
  if (!el) return;
  try {
    const variant = JSON.parse(el.textContent);
    updateGalleryForVariant(variant);
  } catch (e) {
    console.error("Erro ao ler variante:", e);
  }
}

document.addEventListener("DOMContentLoaded", () => initProductGallerySlick(document));

document.addEventListener("shopify:section:load", (e) =>
  initProductGallerySlick(e.target)
);

document.addEventListener(
  "change",
  (event) => {
    if (!event.target.closest("variant-selects")) return;
    setTimeout(onVariantSelected, 300);
    setTimeout(onVariantSelected, 700);
  },
  true
);

if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
  subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
  const { sectionId, html, variant } = event.data || {};
  if (html && sectionId) {
    refreshModalContent(html, sectionId);
  }
  if (variant) updateGalleryForVariant(variant);
});
}